<template>
  <section :ref="'swatchesMain-' + groupName" :class="['swatches-view-swatches-wrapper', { 'organism': configuration.enableAtomicSwatchTray }]">
    <div v-show="$store.state.utils.trayDisabled.swatches" class="disable-swatches"></div>
    <div :class="['swatches-view-swatches-wrapper-container', { scrollActive: scrollActive }]">
      <div class="swatches-view-swatches-wrapper-container-scroll">
        <Swatches
          v-if="configuration.enableAtomicSwatchTray"
          :activeGroup="activeGroup"
          :customStyle="{ transform: `translate(${this.scrollValue}px, 0px)`,
            transition: `transform ${this.scrollSpeed}s ease 0s`}"
          :groupName="groupName"
          :swatchesToRenderOrdered="swatchesToRenderOrdered"
        />
       <div
          v-else
          :ref="'swatchesWrapper-' + groupName"
          :class="[
            'swatches-view-swatches-wrapper-container-scroll-content',
            'swatches-' + groupName + '-container',
            { swatchesContainerActive: activeGroup == groupName }
          ]"
          :style="{ transform: `translate(${this.scrollValue}px, 0px)`, transition: `transform ${this.scrollSpeed}s ease 0s`}"
        >
          <div
            v-show="hasTitleProperties(groupName)"
            class="swatches-view-swatches-wrapper-container-scroll-content is-group-title"
          >
            <div class="group-title">
              <span class="group-text title">
                {{ getTabData(groupName).title }}
              </span>
              <span class="group-text subtitle">
                {{ getTabData(groupName).subtitle }}
              </span>
            </div>
          </div>
          <div
            class="swatches-view-swatches-wrapper__swatches-container"
            v-for="(subgroups, index) in swatchesToRenderOrdered"
            :key="subgroups.palette_id || subgroups.name"
          >
            <keep-alive :max="10" v-if="subgroups.swatches && subgroups.swatches.length || !configuration.enableCollapsingSwatches">
              <swatches
                :key="subgroups.palette_id || subgroups.name"
                :swatchesArray="subgroups.swatches"
                :subgroup="subgroups"
                :groupName="groupName"
                :hasModal="hasModal(subgroups)"
                :isFirstSubgroup="index === 0"
              >
              </swatches>
            </keep-alive>
          </div>
       </div>
      </div>
      <div
        :class="[
          'swatches-view-swatches-wrapper-container-navigation',
          { 'organism': configuration.enableAtomicSwatchTray },
          { scrollNavigationActive: activeGroup == groupName }
        ]"
        v-show="scrollActive"
      >
        <button
          aria-label="swatches navigation button left"
          role="button"
          :class="['swatches-view-swatches-wrapper-container-navigation-button clear button', { disabledScroll: disableLeftButton }]"
          :disabled="disableLeftButton"
          @click="scrollLeft">
          <span ref="scrollOverLeft" class="icon-arrow-left-indicator"></span>
        </button>
        <button
          aria-label="swatches navigation button right"
          role="button"
          :class="['swatches-view-swatches-wrapper-container-navigation-button clear button', { disabledScroll: disableRightButton }]"
          :disabled="disableRightButton"
          @click="scrollRight">
          <span  ref="scrollOverRight" class="icon-arrow-right-indicator"></span>
        </button>
      </div>
    </div>
  </section>
</template>

<script>
import swatches from '@/components/Swatches/SwatchesWrapper/SwatchesComponent';
import Swatches from '@/components/organism.swatches.vue';

const DEFAULT_TAB = 'solids';

export default {
  name: "swatchesWrapper",
  components: {
    swatches,
    Swatches
  },
  data() {
    return {
      scrollValue: 0,
      scrollOffset: null,
      scrollSpeedDisabled: false,
      windowWidth: 0,
      disableLeftButton: true,
      disableRightButton: false
    };
  },
  props: {
    swatchesToRender: {
      type: Object,
      default: function() {
        return {};
      },
      required: true
    },
    groupName: {
      type: String,
      default: "",
      required: true
    },
    activeGroup: {
      type: String,
      default: "",
      required: true
    }
  },
  computed: {
    activeComponent() {
      if (this.$store.getters['utils/isApparelEnabled']){
        return this.$store.state.standardNavigation.activeSubComponent
          ? `${this.$store.state.standardNavigation.activeComponent}/${this.$store.state.standardNavigation.activeSubComponent}`
          : this.$store.state.standardNavigation.activeComponent;
      }
      return this.$store.state.legacyNavigation.activeComponent;
    },
    groupTabs() {
      return this.$store.state.swatches.groupTabs;
    },
    scrollSpeed() {
      return this.scrollSpeedDisabled ? 0 : this.$store.state.utils.configuration.scrollSpeed;
    },
    selectedTabPerComponent(){
      return this.$store.state.swatches.selectedTabs[this.activeComponent];
    },
    hasNoSubgroups() {
      let componentName = this.activeComponent;
      if (String(this.activeComponent).search('/') !== -1) {
        componentName = 'sub_component';
      }
      const group = DEFAULT_TAB;
      const swatchData = this.$store.state.swatches.swatchesByComponent &&
        this.$store.state.swatches.swatchesByComponent[componentName] &&
        this.$store.state.swatches.swatchesByComponent[componentName][this.activeGroup];
      return this.activeGroup === group &&
        !!swatchData && Object.keys(swatchData).length === 1 &&
        !!swatchData[group] && !!swatchData[group].length;
    },
    /*
     * @computed - blockedPalettes
     * Array with subgroup IDs with swatches that have unique_swatch attribute as true AND with palette IDs with palette_lock attribute as 1
     */
    blockedPalettes() {
      const swatchesListByComponent = this.$store.state.swatches.swatchesListByComponent[this.activeComponent];

      return [
        ...this.$store.getters['swatches/lockedPalettes'].reduce((whole, { id }) => {
          const activeBlockedPalettes = Object.keys(this.$props.swatchesToRender).filter(renderId => id === parseInt(renderId));

          if (id && !whole.includes(id) && activeBlockedPalettes.length) {
            whole.push(id);
          }
          return whole;
        }, []),
        ...this.$store.getters['swatches/uniqueSwatches'].reduce((whole, swatch) => {
          const subgroupId = this.$store.getters['swatches/returnSwatchSubgroupName']({ swatch });

          if (swatchesListByComponent && swatchesListByComponent.includes(swatch.id) && subgroupId && !whole.includes(subgroupId)) {
            whole.push(subgroupId);
          }

          return whole;
        }, [])
      ];
    },
    ugcBlockedPalette() {
      return this.$store.state.ugc.ugcBlockedPalettes[this.activeComponent] || null;
    },
    swatchesToRenderOrdered() {
      const array = [];
      for (let key in this.swatchesToRender) {
        // If there is ugc_locked palette and is the current one
        const ugcPaletteLock = this.ugcBlockedPalette && this.ugcBlockedPalette === parseInt(this.swatchesToRender[key].palette_id);
        // If there are palette_lock palettes and current one is included in those ones (palettes or subgroups)
        const paletteLock = !this.blockedPalettes.length
        || (this.blockedPalettes.includes(parseInt(this.swatchesToRender[key].palette_id))
        || this.blockedPalettes.includes(this.swatchesToRender[key].name));

        if (ugcPaletteLock || paletteLock) {
          array.push(this.swatchesToRender[key]);
        }
      }
      array.sort((a, b) => a.order - b.order);
      return array;
    },
    noStyledScroll() {
      return this.windowWidth < 1024;
    },
    scrollActive() {
      return !this.hasNoSubgroups && (!this.disableRightButton || !this.disableLeftButton);
    },
    configuration() {
      return this.$store.state.utils.configuration;
    },
  },
  watch: {
    selectedTabPerComponent: function() {
      this.setScrollOffset();
    },
    activeComponent: function() {
      this.setScrollOffset();
      this.changeSwatchesScrollPosition(this.scrollOffset);
    },
    activeGroup: function(newGroup, oldGroup) {
      if(newGroup !== oldGroup) {
        this.setScrollOffset();
      }
    }
  },
  methods: {
    hasModal({ modal_url, feature_modal }) {
      return !!this.ugcBlockedPalette || (modal_url && modal_url !== "") || feature_modal;
    },
    setScrollOffset() {
      let subgroup;
      if (this.configuration.enableAtomicSwatchTray)
        subgroup = document.getElementById(`swatchesWrapper-${ this.groupName }`);
      else
        subgroup = this.$refs[`swatchesWrapper-${ this.groupName }`];
      if(!subgroup) return false;
      const swatchEl = subgroup.getElementsByClassName("swatch")[0];
      if(!swatchEl) return false;
      this.scrollOffset = swatchEl.clientWidth + 350;
      // check the scroll after the set scroll off set
      this.scrollRightDisabled();
      this.scrollLeftDisabled();
    },
    scrollLeft() {
      if(!this.disableLeftButton) {
        const position = this.returnPrevSwatchScrollPosition();
        this.scrollValue -= position;
        this.getLastScrollValue();
      }
    },
    scrollRight() {
      if(!this.disableRightButton) {
        const position = this.returnNextSwatchScrollPosition();
        this.scrollValue += position;
        this.getLastScrollValue();
      }
    },
    scrollRightDisabled() {
      // scroll value 1 will be considered as zero to disable right arrow
      const localScroll = this.scrollValue === 1 ? 0 : this.scrollValue;
      if (localScroll <= -this.getSwatchesWidth()) {
        this.disableRightButton = true;
        return true;
      } else {
        this.disableRightButton = false;
        return false;
      }
    },
    scrollLeftDisabled() {
      if (this.scrollValue >= 0) {
        this.disableLeftButton = true;
        return true;
      } else {
        this.disableLeftButton = false;
        return false;
      }
    },
    getSwatchesWidth() {
      const element = document.getElementsByClassName(`swatches-${ this.activeGroup }-container`)[0];
      if (!element) return false;

      return element.scrollWidth - element.clientWidth;
    },
    getLastScrollValue() {
      // set scroll buttons on each click
      this.scrollRightDisabled();
      this.scrollLeftDisabled();
      // get the last the scroll value if the value is NAN
      if(isNaN(this.scrollValue)) {
        this.scrollValue = Number(window.getComputedStyle(document.getElementsByClassName(`swatches-${this.activeGroup}-container`)[0]).transform.split(",")[4]);
      }
      if(!this.scrollOffset) {
        this.setScrollOffset();
      }
    },
    returnNextSwatchScrollPosition(){
      const parentEl = document.getElementsByClassName(`swatches-${this.activeGroup}-container`)[0];
      const scrollNavWidth = document.getElementsByClassName('scrollNavigationActive')[0].getBoundingClientRect().width;
      const maxScrollWith = -(parentEl.scrollWidth - (window.innerWidth-scrollNavWidth));
      const swatchesEls = parentEl.getElementsByClassName("swatch");
      for (let item of swatchesEls) {
        const boundingBox = item.getBoundingClientRect();
        if (boundingBox.right >= (window.innerWidth-scrollNavWidth)) {
          const nextScroll = (window.innerWidth-scrollNavWidth) - (boundingBox.right + this.scrollOffset);
          const totalScroll = this.scrollValue + nextScroll;
          if (totalScroll < maxScrollWith) {
            return maxScrollWith - this.scrollValue;
          }
          return nextScroll;
        }
      }
    },
    returnPrevSwatchScrollPosition(){
      const parentEl = document.getElementsByClassName(`swatches-${this.activeGroup}-container`)[0];
      const swatchesEls = parentEl.getElementsByClassName("swatch");
      for (let item of swatchesEls) {
        const boundingBox = item.getBoundingClientRect();
        if (boundingBox.left >= 0) {
          const nextScroll = - (boundingBox.left + this.scrollOffset);
          const totalScroll = this.scrollValue - nextScroll;
          if (totalScroll > 0) {
            return nextScroll+totalScroll;
          }
          return nextScroll;
        }
      }
    },
    hasTitleProperties(group) {
      return this.getTabData(group).title || this.getTabData(group).subtitle ;
    },
    getTabData(group) {
      return this.groupTabs[group];
    },
    onWindowRezise(){
      this.windowWidth = window.innerWidth;
      if (this.noStyledScroll) {
        this.scrollValue = 0;
      }
      this.$store.commit("swatches/SET_TAB_CONTAINER_SIZE", this.windowWidth);
      // check the scroll after the set scroll off set
      this.scrollRightDisabled();
      this.scrollLeftDisabled();
    },
    changeSwatchesScrollPosition(swatchOffset = 0) {
      let newOffset;
      if (this.noStyledScroll) {
        if (this.activeGroup !== this.groupName) {
          newOffset = 0;
        } else {
          newOffset = Math.floor(swatchOffset - (this.windowWidth / 2));
        }
        this.$refs[`swatchesMain-${ this.groupName }`].scrollTo(newOffset, 0);
      } else {
        newOffset = Math.floor((this.windowWidth / 2) - swatchOffset);
        this.scrollSpeedDisabled = true;
        this.$nextTick(() => {
          if (isNaN(newOffset) || newOffset > 0 || this.activeGroup !== this.groupName) {
            this.scrollValue = 1;
          } else if (newOffset < -this.getSwatchesWidth()) {
            this.scrollValue = this.getSwatchesWidth() === 0 ? 1 : -this.getSwatchesWidth();
          } else {
            this.scrollValue = newOffset;
          }
          this.scrollRightDisabled();
          this.scrollLeftDisabled();

          setTimeout(() => this.scrollSpeedDisabled = false, 150);
        });
      }
    }
  },
  mounted() {
    const totalWidth = this.windowWidth;
    this.$store.commit("swatches/SET_TAB_CONTAINER_SIZE", totalWidth);
    this.setScrollOffset();
  },
  created() {
    this.setScrollOffset();
    this.onWindowRezise();
    window.addEventListener('resize', this.onWindowRezise);
    this.$eventBus.$on('changeSwatchesScrollPosition', this.changeSwatchesScrollPosition);
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.onWindowRezise);
    this.$eventBus.$off('changeSwatchesScrollPosition', this.changeSwatchesScrollPosition);
  }
};
</script>